import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ArrowRightLeft, AlertTriangle } from "lucide-react";
import api from "../lib/api";

export const TransferAlerts = ({ user }) => {
  const [a, setA] = useState({ incoming: 0, incidents: 0 });
  const navigate = useNavigate();
  const { pathname } = useLocation();
  useEffect(() => {
    if (!user || !["admin", "manager"].includes(user.role)) return undefined;
    let alive = true;
    const poll = () => api.get("/group/transfers/alerts").then((r) => { if (alive) setA(r.data); }).catch(() => {});
    poll();
    const t = setInterval(poll, 30000);
    window.addEventListener("transfers-changed", poll);
    return () => { alive = false; clearInterval(t); window.removeEventListener("transfers-changed", poll); };
  }, [user]);
  if ((!a.incoming && !a.incidents) || pathname.startsWith("/app/negocios")) return null;
  const go = () => navigate("/app/negocios?tab=transfers");
  return (
    <div className="fixed bottom-4 left-4 lg:left-72 z-[55] w-[92%] max-w-sm space-y-2" data-testid="transfer-alerts">
      {a.incoming > 0 && (
        <button data-testid="transfer-alert-incoming" onClick={go} className="w-full text-left bg-[#1F2937] text-white rounded-2xl shadow-2xl p-4 flex items-center gap-3 hover:bg-[#111827]">
          <span className="w-10 h-10 rounded-xl bg-[#E85D04] flex items-center justify-center shrink-0"><ArrowRightLeft size={20} /></span>
          <span className="flex-1"><b className="block">{a.incoming} traspaso(s) por recibir</b><span className="text-xs text-white/70">Toca para revisar y aceptar</span></span>
        </button>
      )}
      {a.incidents > 0 && (
        <button data-testid="transfer-alert-incidents" onClick={go} className="w-full text-left bg-[#DC2626] text-white rounded-2xl shadow-2xl p-4 flex items-center gap-3 hover:bg-[#B91C1C]">
          <span className="w-10 h-10 rounded-xl bg-white/20 flex items-center justify-center shrink-0"><AlertTriangle size={20} /></span>
          <span className="flex-1"><b className="block">{a.incidents} incidencia(s) en tus traspasos</b><span className="text-xs text-white/80">Una sucursal reportó diferencias</span></span>
        </button>
      )}
    </div>
  );
};
